/**
 * @file 合作咨询 url
 */

export default {
    cooperateUpload: {
        url: '/exp/cooperate/upload',
        method: 'post'
    },
    searchCompanyName: {
        url: "/exp/cooperate/searchCompanyName",
        method: 'get'
    },
    cooperateSave: {
        url: '/exp/cooperate/save',
        method: 'post'
    }
} as Record<string, NetTypes.Api>;
